var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 11.25H6.75C5.92157 11.25 5.25 11.9216 5.25 12.75V18C5.25 18.8284 5.92157 19.5 6.75 19.5H17.25C18.0784 19.5 18.75 18.8284 18.75 18V12.75C18.75 11.9216 18.0784 11.25 17.25 11.25Z",
    stroke: "#555770",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 11.25V8.25C8.25 7.25544 8.64509 6.30161 9.34835 5.59835C10.0516 4.89509 11.0054 4.5 12 4.5C12.9946 4.5 13.9484 4.89509 14.6517 5.59835C15.3549 6.30161 15.75 7.25544 15.75 8.25V11.25",
    stroke: "#555770",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassword);
export default __webpack_public_path__ + "static/media/Password.8878579c6b85c3010619ad9d9499896d.svg";
export { ForwardRef as ReactComponent };